(() => {
  if (window.__faithShopNavigationLoaded) return;
  window.__faithShopNavigationLoaded = true;
  // Delegated listeners also work after Shopify replaces a header section.
  document.addEventListener("click", (event) => {
    document.querySelectorAll(".shop-nav__dropdown[open]").forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute("open");
    });
  });
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    document.querySelectorAll(".shop-nav__dropdown[open]").forEach((dropdown) => {
      const restoreFocus = dropdown.contains(document.activeElement);
      dropdown.removeAttribute("open");
      if (restoreFocus) dropdown.querySelector("summary")?.focus();
    });
  });
})();
